export { default } from './EduPlanCard'
